__turbopack_context__.v({
  "dropdown_btn": "ij7yVa_dropdown_btn",
  "dropdown_wrapper": "ij7yVa_dropdown_wrapper",
  "text_content": "ij7yVa_text_content",
});
